//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import {
    CustomEventParticipantAttendeeStatusFilter,
    CustomEventParticipantEventFilter,
    CustomEventParticipantRsvpFilter,
    CustomEventParticipantOfficialsFilter,
    CustomEventParticipantStaffersFilter,
    CustomEventParticipantContactsFilter,
    CustomEventParticipantPressContactsFilter,
    CustomEventParticipantInvitedFilter,
    CustomEventParticipantBossFilter,
    CustomEventParticipantOfficialFilter,
    CustomEventParticipantStafferFilter,
    CustomEventParticipantContactFilter,
    CustomEventParticipantPressContactFilter,
    CustomEventParticipantDateFilter,
    CustomEventParticipantDatePickerStartFilter,
    CustomEventParticipantDatePickerEndFilter,
} from "shared/search/containers/Filter/CustomEventParticipantFilters"

const defaultPropTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export const CustomEventParticipantEventFilterGroup = (props) => genericFilterGroup(props)
CustomEventParticipantEventFilterGroup.propTypes = defaultPropTypes
CustomEventParticipantEventFilterGroup.defaultProps = {
    filters: [CustomEventParticipantEventFilter],
    uniqueFilterGroupId: "customEventParticipantEventFilterGroup",
    displayLabel: "Event",
    helpText: "Filter by the Event that the Event Participant has been invited to",
}

export const CustomEventParticipantStatusFilterGroup = (props) => genericFilterGroup(props)
CustomEventParticipantStatusFilterGroup.propTypes = defaultPropTypes
CustomEventParticipantStatusFilterGroup.defaultProps = {
    filters: [CustomEventParticipantRsvpFilter, CustomEventParticipantAttendeeStatusFilter],
    uniqueFilterGroupId: "customEventParticipantStatusFilterGroup",
    displayLabel: "Status",
    helpText: "Filter by current status of Event Participant",
}

export const CustomEventParticipantRecipientsFilterGroup = (props) => genericFilterGroup(props)
CustomEventParticipantRecipientsFilterGroup.propTypes = defaultPropTypes
CustomEventParticipantRecipientsFilterGroup.defaultProps = {
    filters: [
        CustomEventParticipantOfficialFilter,
        CustomEventParticipantStafferFilter,
        CustomEventParticipantContactFilter,
        CustomEventParticipantPressContactFilter,

        CustomEventParticipantOfficialsFilter,
        CustomEventParticipantStaffersFilter,
        CustomEventParticipantContactsFilter,
        CustomEventParticipantPressContactsFilter,
        CustomEventParticipantInvitedFilter,
        CustomEventParticipantBossFilter,
    ],
    uniqueFilterGroupId: "customEventRecipientsFilterGroup",
    displayLabel: "Recipients",
    helpText: "Filter by recipient of the Event invite",
}

export const CustomEventParticipantDateFilterGroup = (props) => genericFilterGroup(props)
CustomEventParticipantDateFilterGroup.propTypes = defaultPropTypes
CustomEventParticipantDateFilterGroup.defaultProps = {
    filters: [
        CustomEventParticipantDateFilter,
        CustomEventParticipantDatePickerStartFilter,
        CustomEventParticipantDatePickerEndFilter,
    ],
    uniqueFilterGroupId: "customEventParticipantDateFilterGroup",
    displayLabel: "Event Date",
    helpText: "Filter for Event Participants by date of Event.",
}
